import React from 'react';
import PropTypes from 'prop-types';
import { getClientEnvironmentDetails } from '@sm/utils';
import { defineMessages, T } from '@sm/intl';
import getFooterLanguageList from './helpers/getFooterLanguageList';
import { InlineList, InlineListItem } from '../InlineList';

const COPY = defineMessages({
  LANGUAGES: {
    id: 'LanguageListLO.languageMenu',
    defaultMessage: 'Language:',
    description:
      '[Type: Label][Vis.: med] - A label for logged out footer language list'
  }
});

const LanguageListLO = ({ domain, tld }) => {
  const envDetails = getClientEnvironmentDetails();
  const languageItems = getFooterLanguageList(
    envDetails.isBrowser ? window.location.href : '',
    tld
  ).map(lang => {
    const path = envDetails.isBrowser ? window.location.pathname : '';
    return (
      <InlineListItem
        key={lang.name}
        href={`https://${lang.subdomain}.${domain}.${lang.tld}${path}?ut_source=footer`}
      >
        {lang.displayName}
      </InlineListItem>
    );
  });
  return (
    <InlineList>
      <InlineListItem isTitle>
        <T desc={COPY.LANGUAGES} />
      </InlineListItem>
      {languageItems}
    </InlineList>
  );
};

LanguageListLO.propTypes = {
  domain: PropTypes.string.isRequired,
  tld: PropTypes.string.isRequired
};

export default LanguageListLO;
